import angular from 'angular'

import { isProductActive } from './product-index-util'
import type { ExactMatchIndex } from './exact-match-index'

/**
 * A search index for searching for active products by exact SKU match.
 *
 * @param {ExactMatchIndex} ExactMatchIndex - The factory for creating exact match indexes.
 * @returns {ExactMatchIndex} The exact match index for searching for active products by SKU.
 */
function productSkuIndex(ExactMatchIndex: ExactMatchIndex) {
  return ExactMatchIndex.create({
    name: 'productSkuIndex',
    entityName: 'product',
    entityStoreName: 'products',
    databaseIndexName: 'byProductCode',
    filterResultsBy: isProductActive,
  })
}

export type ProductSkuIndex = ReturnType<typeof productSkuIndex>

/**
 * A search index for searching for active products by exact SKU match.
 *
 * @module productSkuIndex
 */
angular
  .module('webregister.factories')
  .factory('productSkuIndex', productSkuIndex)
